<template>
  <div>
    <Form ref="articleForm" v-model="articleDataInfo" :label-width="80">
      <FormItem label="公告标题" required>
        <Input type="text" v-model="articleDataInfo.title"></Input>
      </FormItem>
      <FormItem label="公告时间">
        <DatePicker :value="noticeDate" @on-change="DateChange" class="picker" type="datetime" v-model="articleDataInfo.articleDate" format="yyyy-MM-dd HH:mm" placeholder="挂网日期" style="width: 200px;"></DatePicker>
        <span>（公告发布时间，需要时修改）</span>
        <template v-if="editorId==='e-invite'||editorId==='e-invite1'||editorId==='e-survey'">
          <Checkbox :disabled="!ifShowFile" v-model="ifEndShowFile" style="margin-left:10px;">截止报名后展示公告文件</Checkbox>
          <Checkbox v-model="ifGroupFee">是否按包组计算报名费</Checkbox>
        </template>
      </FormItem>
      <FormItem label="文件上传" :required="(editorId==='e-invite'||editorId==='e-invite1'||editorId==='e-survey')&&ifShowFile">
        <Input type="text" v-model="articleDataInfo.fileUrl" style="width:700px;margin-right:10px;" readonly></Input>
        <Button type="primary" @click="uploadFileSelect" style="margin-right:5px;">上传</Button>
        <input type="file" ref="uploadFile" style="display:none" @change="fileUpload">
        <Button type="primary" @click="copyUrl">复制链接</Button>
        <input type="text" ref="fileUrl" style="width:1px;border:0;position:absolute;right:9999px;" id="fileUrl">
      </FormItem>
      <FormItem v-if="editorId==='e-invite'||editorId==='e-invite1'||editorId==='e-survey'" style="display:inline-block">
        <Checkbox v-model="ifShowFile">公布展示公告文件</Checkbox>
        <Checkbox v-model="ifGetFsFile">获取最新上传发售稿作为附件</Checkbox>
        <Checkbox v-model="isFillBrand">是否需要供应商填写产品品牌</Checkbox>
        <!-- <Checkbox v-model="isNewFlow">新审核流程（去除资料审核环节）</Checkbox> -->
      </FormItem>
      <FormItem style="display:inline-block">
        <Checkbox v-model="ifShowArticle">官网显示此公告</Checkbox>
        <Checkbox v-model="isInternational">国际竞赛</Checkbox>
        <Checkbox v-model="isOpenDetail" v-if="rolePermission">官网展示公告详情</Checkbox>
      </FormItem>
    </Form>
    <editor :editorId="editorId" ref="editor"></editor>
    <div style="text-align:right;margin-top:5px;">
      <Button @click="cancel" style="margin-right:5px;">取消</Button>
      <Button type="primary" @click="createArticles">确定</Button>
    </div>
  </div>
</template>

<script>
import editor from '@/components/editor'
import ajax from '@/lib/ajax'
import requestUrls from '@/lib/requestUrls'
import axios from 'axios'
import { formatDate } from '@/lib/tool'
import localFile from '@/lib/localFile'

export default {
  name: 'articleEditor',
  props: {
    // 公告类型
    editorId: {
      type: String,
      required: true
    },
    // 公告信息
    articleInfo: {
      type: Object
    },
    projectData: {
      type: Object
    },
    selectArticle: {
      type: Object
    }
  },
  data() {
    return {
      articleDataInfo: {
        title: '',
        articleDate: '',
        fileUrl: '',
      },
      // username: '',
      ifShowFile: false,
      ifEndShowFile: false,
      ifGroupFee: false,
      noticeDate: '',
      articleDate: '',
      ifGetFsFile: false,
      ifShowArticle: true,
      isInternational: false,
      isFillBrand: false,
      // isNewFlow: true,
      isOpenDetail: false
    }
  },
  components: {
    editor
  },
  created() {
    this.articleDataInfo.articleDate = new Date()
  },
  computed: {
    username () {
      return this.$store.state.session.user.name
    },
    rolePermission () {
      return this.$store.getters['session/hasRoles']('信息中心')
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    async createArticles() {
      if (!this.articleDataInfo.title) {
        this.$Message.error('请输入公告标题')
        return
      }
      if (this.$refs.editor.getText() === '') {
        this.$Message.error('请输入公告内容')
        return
      }
      // 判断公告类型
      let ext2 = ''
      let amount = ''
      let endTime = ''
      let isApply = false
      let ifShowFile = false
      let ifEndShowFile = false
      //招标
      if (this.editorId === 'e-invite' || this.editorId === 'e-invite1' || this.editorId === 'e-survey') {
        ext2 = this.editorId === 'e-survey' ? '74170' : '74166'
        amount = this.articleInfo.enrollFee
        endTime = formatDate(this.articleInfo.enrollEndDate)
        ifShowFile = this.ifShowFile
        ifEndShowFile = this.ifEndShowFile
        if (this.articleInfo.isWebEnroll === "是") {
          isApply = true
        }
        if (this.articleDataInfo.fileUrl === '' && this.ifShowFile) {
          this.$Message.error('请上传发售稿文件，并附加文件链接在公告内容上')
          return
        }
      }
      // 更正
      if (this.editorId === 'e-correct' || this.editorId === 'e-correct1') {
        ext2 = '74169'
        ifShowFile = true
        ifEndShowFile = true
      }
      // 中标
      if (this.editorId === 'e-bidding') {
        ext2 = '74168'
        ifShowFile = true
        ifEndShowFile = true
      }
      this.$Spin.show()
      try {
        // 添加公告
        let articleRep = await ajax.post(requestUrls.articles.CreateOrUpdate, {
          "abpArticles": {
            "id": this.selectArticle.id,
            "areas": this.projectData.district,
            "title": this.articleDataInfo.title,
            "projectType": this.projectData.buyerModes,
            "projectNo": this.projectData.projectFull,
            "amount": amount,
            "objectId": this.projectData.id,
            "industry": this.projectData.clientSys,
            "endTime": endTime,
            "ext2": ext2,
            "isApply": isApply,
            "isGroupCalc": this.ifGroupFee,
            "fileDispaly": ifShowFile,
            "endTimeDispaly": ifEndShowFile,
            "creationTime": formatDate(this.articleDate),
            "isUnion": false,
            "fileUrl": this.articleDataInfo.fileUrl,
            "projectShort": this.projectData.projectShort,
            "isDispaly": this.ifShowArticle,
            "isInternational": this.isInternational,
            "isFillBrand": this.isFillBrand,
            "isNewFlow": true,
            "isOpenDetail": this.isOpenDetail
          }
        })
        // 添加公告内容
        let articleDataRep = await ajax.post(requestUrls.articlesData.CreateOrUpdate, {
          "abpArticleData": {
            "id": this.selectArticle.articleContentId,
            "articlesId": articleRep.data.result.id,
            "content": this.$refs.editor.getHtml()
          }
        })
        this.$Spin.hide()
        if (articleDataRep.data.success) {
          this.$Message.success('公告发布成功')
          this.$emit('addSuccess')
          // 发送定时消息
          if (this.projectData.projectProperty === '政府采购') {
            // 委托协议
            ajax.get(requestUrls.CLTrustAgreementInfo.GetPaged, {
              params: {
                filter: `projectId == ${this.projectData.id}`
              }
            }).then(async (res) =>{
              let agreement = res.data.result.items
              if (res.data.result.totalCount && agreement[0].ifKnow === '可以获悉') {
                // 是否已有定时通知任务
                let rep = await ajax.get(requestUrls.EnrollNoticeTask.GetPaged, {
                  params: {
                    filter: `projectId == ${this.projectData.id}`
                  }
                })
                if (!rep.data.result.totalCount) {
                  ajax.post(requestUrls.EnrollNoticeTask.CreateOrUpdate, {
                    "enrollNoticeTask": {
                      "projectId": this.projectData.id,
                      "taggetDept": this.projectData.purchaserName,
                      "taggetPerson": agreement[0].partyAContact,
                      "phoneNumber": agreement[0].partyAContactNumber,
                      "noticeStatus": "0",
                      "result": ""
                    }
                  })
                }
              }
            })
          }
        } else {
          this.$Message.error('公告发布失败')
        }
      } catch (err) {
        this.$Spin.hide()
        this.$Message.error('公告发布失败')
      }
    },
    uploadFileSelect() {
      this.$refs.uploadFile.click()
    },
    copyUrl() {
      if (!this.articleDataInfo.fileUrl) {
        this.$Message.error('请先上传文件')
        return
      }
      this.$refs.fileUrl.value = this.articleDataInfo.fileUrl
      this.$refs.fileUrl.select()
      document.execCommand('copy')
      this.$Message.success('复制成功')
    },
    async fileUpload() {
      let fl = ''
      let fileclass = ''
      //招标
      if (this.editorId === 'e-invite' || this.editorId === 'e-invite1') {
        fl = '32'
        fileclass = '招标文件发售稿'
      }
      // 更正
      if (this.editorId === 'e-correct' || this.editorId === 'e-correct1') {
        fl = '17'
        fileclass = '更正公告'
      }
      // 中标
      if (this.editorId === 'e-bidding') {
        fl = '27'
        fileclass = '中标公告网站截图'
      }
      this.$Spin.show()
      try {
        // let formData = new FormData()
        // formData.append('fileToUpload', this.$refs.uploadFile.files[0])
        // formData.append('username', this.username)
        // formData.append('fl', fl)
        // formData.append('fileclass', fileclass)
        // formData.append('npid', this.projectData.id)
        // let rep = await axios.post('http://oa.chinapsp.cn:8088/FileModule/Gdfile/AbpUpload', formData)

        let fileRep = await localFile.uploadFile(this.$refs.uploadFile.files[0])

        if (!fileRep) {
          throw 'uploadError'
        }

        // 提交记录
        const params = {
          projectId: this.projectData.id,
          fileName: fileRep.fileName,
          fileGuid: fileRep.serviceGuid,
          fileSuffix: fileRep.extension,
          fileTypeId: fl,
          uploadPerson: this.username,
          fileTypeName: fileclass
        }
        let recordRep = await localFile.createFileRecord(params)

        if (!recordRep) {
          throw 'RecordError'
        }

        this.$Spin.hide()
        this.$refs.uploadFile.value = ''

        this.$Message.success('上传成功')

        this.articleDataInfo.fileUrl = localFile.getDownUrl(fileRep.serviceGuid)

        // let file = rep.data.fileName
        // let lastIndex = file.lastIndexOf('.')
        // file = file.substring(0, lastIndex)
        // let fileName = encodeURIComponent(file)
        // this.articleDataInfo.fileUrl = `http://oa.chinapsp.cn:8088/FileServer/CaiLianFile/down2?fileid=${rep.data.fileId}&filename=${fileName}`

      } catch (err) {
        console.error(err)
        this.$refs.uploadFile.value = ''
        this.$Spin.hide()
        this.$Message.error('上传失败')
      }
    },
    refreshInfo() {
      this.ifShowFile = false
      this.ifShowArticle = true
      this.isInternational = false
      this.isFillBrand = false
      this.isOpenDetail = false
      // this.isNewFlow = true
      this.articleDataInfo.title = ''
      this.articleDataInfo.articleDate = ''
      this.articleDataInfo.fileUrl = ''
      this.ifGetFsFile = false
      this.$refs.editor.clearContent()
    },
    DateChange(val) {
      this.articleDate = val
    }
  },
  watch: {
    ifShowFile(val) {
      if (!val) {
        this.ifEndShowFile = false
      }
    },
    ifShowArticle(val) {
      if (!val) {
        this.$Notice.warning({
          title: '官网不显示公告',
          desc: '注意，去掉此勾选后官网将不显示此公告，请谨慎处理。'
        })
      }
    },
    selectArticle(val) {
      this.ifShowFile = val.fileDispaly
      this.ifShowArticle = val.isDispaly
      this.isInternational = val.isInternational
      this.isFillBrand = val.isFillBrand
      this.isOpenDetail = val.isOpenDetail
      // this.isNewFlow = val.isNewFlow
      this.ifEndShowFile = val.endTimeDispaly
      this.ifGroupFee = val.isGroupCalc
      this.articleDataInfo.title = val.title
      this.$refs.editor.setHtml(val.articleContent)
      this.articleDataInfo.fileUrl = val.fileUrl
      if (val.creationTime) {
        this.articleDataInfo.articleDate = val.creationTime.replace('T', ' ')
        this.articleDate = val.creationTime.replace('T', ' ')
      } else {
        this.articleDataInfo.articleDate = formatDate()
        this.articleDate = formatDate()
      }
    },
    articleInfo(val) {
      if (val) {
        this.noticeDate = new Date()
        if (val.creationTime) {
          this.noticeDate = new Date(val.creationTime)
        }
      }
    },
    async ifGetFsFile(val) {
      if (val) {
        const params = {
          filter: `fileTypeId=="32" and projectId=="${this.projectData.id}"`
        }
        let rep = await ajax.get(requestUrls.clfile.getList, { params })
        const file = rep.data.result[rep.data.result.length - 1]
        this.articleDataInfo.fileUrl = localFile.getDownUrl(file.fileGuid)

        // let rep = await axios.post(`http://oa.chinapsp.cn:8088/FileModule/Gdfile/AbpGetFileList?npid=${this.projectData.id}&fl=32`)
        // this.articleDataInfo.fileUrl = `http://oa.chinapsp.cn:8088/FileServer/CaiLianFile/down2?fileid=${rep.data.result[rep.data.result.length - 1]['文件Guid']}&filename=${rep.data.result[rep.data.result.length - 1]['文件原名'].split('.')[0]}`
      } else {
        this.articleDataInfo.fileUrl = ''
      }
    }
  }
}
</script>

<style lang="less">
.picker {
  .ivu-select-dropdown {
    z-index: 11000;
  }
}
</style>
